(ns common.currencies
  (:require
   [clojure.set :as set]
   [clojure.string :as string]
   [common.util :as cu]))

(def iso-4217-currency-data
  [["AED" "784" "United Arab Emirates dirham" "د.إ" "fils"]
   ["AFN" "971" "Afghan afghani" "؋" "pul"]
   ["ALL" "8" "Albanian lek" "L" "qindarkë"]
   ["AMD" "51" "Armenian dram" "դր." "luma"]
   ["ANG" "532" "Netherlands Antillean guilder" "ƒ" "cent"]
   ["AOA" "973" "Angolan kwanza" "Kz" "cêntimo"]
   ["ARS" "32" "Argentine peso" "$" "centavo"]
   ["AUD" "36" "Australian dollar" "$" "cent"]
   ["AWG" "533" "Aruban florin" "ƒ" "cent"]
   ["AZN" "944" "Azerbaijani manat" "m" "qəpik"]
   ["BAM" "977" "Bosnia and Herzegovina convertible mark" "КМ" "fening"]
   ["BBD" "52" "Barbados dollar" "$" "cent"]
   ["BDT" "50" "Bangladeshi taka" "৳" "paisa"]
   ["BGN" "975" "Bulgarian lev" "лв" "stotinka"]
   ["BHD" "48" "Bahraini dinar" ".د.ب" "fils"]
   ["BIF" "108" "Burundian franc" "Fr" "centime"]
   ["BMD" "60" "Bermudian dollar" "$" "cent"]
   ["BND" "96" "Brunei dollar" "$" "sen"]
   ["BOB" "68" "Boliviano" "Bs." "centavo"]
   ["BRL" "986" "Brazilian real" "R$" "centavo"]
   ["BSD" "44" "Bahamian dollar" "$" "cent"]
   ["BTN" "64" "Bhutanese ngultrum" "Nu." "chetrum"]
   ["BWP" "72" "Botswana pula" "P" "thebe"]
   ["BYR" "974" "Belarusian ruble" "Br" "kapyeyka"]
   ["BZD" "84" "Belize dollar" "$" "cent"]
   ["CAD" "124" "Canadian dollar" "$" "cent"]
   ["CDF" "976" "Congolese franc" "Fr" "centime"]
   ["CHF" "756" "Swiss franc" "Fr" "rappen"]
   ["CLP" "152" "Chilean peso" "$" "centavo"]
   ["CNY" "156" "Chinese yuan" "¥" "fen"]
   ["COP" "170" "Colombian peso" "$" "centavo"]
   ["CRC" "188" "Costa Rican colon" "₡" "cêntimo"]
   ["CUC" "931" "Cuban convertible peso" "$" "centavo"]
   ["CUP" "192" "Cuban peso" "$" "centavo"]
   ["CVE" "132" "Cape Verde escudo" "Esc or $" "centavo"]
   ["CZK" "203" "Czech koruna" "Kč" "haléř"]
   ["DJF" "262" "Djiboutian franc" "Fr" "centime"]
   ["DKK" "208" "Danish krone" "kr" "øre"]
   ["DOP" "214" "Dominican peso" "$" "centavo"]
   ["DZD" "12" "Algerian dinar" "د.ج" "Santeem"]
   ["EGP" "818" "Egyptian pound" "ج.م" "piaster"]
   ["ERN" "232" "Eritrean nakfa" "Nfk" "cent"]
   ["ETB" "230" "Ethiopian birr" "Br" "santim"]
   ["EUR" "978" "Euro" "€" "cent"]
   ["FJD" "242" "Fiji dollar" "$" "cent"]
   ["FKP" "238" "Falkland Islands pound" "£" "penny"]
   ["GBP" "826" "Pound sterling" "£" "penny"]
   ["GEL" "981" "Georgian lari" "ლ" "tetri"]
   ["GHS" "936" "Ghanaian cedi" "₵" "pesewa"]
   ["GIP" "292" "Gibraltar pound" "£" "penny"]
   ["GMD" "270" "Gambian dalasi" "D" "butut"]
   ["GNF" "324" "Guinean franc" "Fr" "centime"]
   ["GTQ" "320" "Guatemalan quetzal" "Q" "centavo"]
   ["GYD" "328" "Guyanese dollar" "$" "cent"]
   ["HKD" "344" "Hong Kong dollar" "$" "cent"]
   ["HNL" "340" "Honduran lempira" "L" "centavo"]
   ["HRK" "191" "Croatian kuna" "kn" "lipa"]
   ["HTG" "332" "Haitian gourde" "G" "centime"]
   ["HUF" "348" "Hungarian forint" "Ft" "fillér"]
   ["IDR" "360" "Indonesian rupiah" "Rp" "sen"]
   ["ILS" "376" "Israeli new shekel" "₪" "agora"]
   ["INR" "356" "Indian rupee" "₹" "paisa"]
   ["IQD" "368" "Iraqi dinar" "ع.د" "fils"]
   ["IRR" "364" "Iranian rial" "﷼" "NULL"]
   ["ISK" "352" "Icelandic króna" "kr" "eyrir"]
   ["JMD" "388" "Jamaican dollar" "$" "cent"]
   ["JOD" "400" "Jordanian dinar" "د.ا" "piastre"]
   ["JPY" "392" "Japanese yen" "¥" "sen"]
   ["KES" "404" "Kenyan shilling" "Sh" "cent"]
   ["KGS" "417" "Kyrgyzstani som" "лв" "tyiyn"]
   ["KHR" "116" "Cambodian riel" "៛" "sen"]
   ["KMF" "174" "Comoro franc" "Fr" "centime"]
   ["KPW" "408" "North Korean won" "₩" "chon"]
   ["KRW" "410" "South Korean won" "₩" "jeon"]
   ["KWD" "414" "Kuwaiti dinar" "د.ك" "fils"]
   ["KYD" "136" "Cayman Islands dollar" "$" "cent"]
   ["KZT" "398" "Kazakhstani tenge" "₸" "tïın"]
   ["LAK" "418" "Lao kip" "₭" "att"]
   ["LBP" "422" "Lebanese pound" "ل.ل" "piastre"]
   ["LKR" "144" "Sri Lankan rupee" "Rs" "cent"]
   ["LRD" "430" "Liberian dollar" "$" "cent"]
   ["LSL" "426" "Lesotho loti" "L" "sente"]
   ["LTL" "440" "Lithuanian litas" "Lt" "centas"]
   ["LYD" "434" "Libyan dinar" "ل.د" "dirham"]
   ["MAD" "504" "Moroccan dirham" "د.م." "centime"]
   ["MDL" "498" "Moldovan leu" "L" "ban"]
   ["MGA" "969" "Malagasy ariary" "Ar" "iraimbilanja"]
   ["MKD" "807" "Macedonian denar" "ден" "deni"]
   ["MMK" "104" "Myanma kyat" "Ks" "pya"]
   ["MNT" "496" "Mongolian tugrik" "₮" "möngö"]
   ["MOP" "446" "Macanese pataca" "P" "avo"]
   ["MRO" "478" "Mauritanian ouguiya" "UM" "khoums"]
   ["MUR" "480" "Mauritian rupee" "₨" "cent"]
   ["MVR" "462" "Maldivian rufiyaa" ".ރ" "laari"]
   ["MWK" "454" "Malawian kwacha" "MK" "tambala"]
   ["MXN" "484" "Mexican peso" "$" "centavo"]
   ["MYR" "458" "Malaysian ringgit" "RM" "sen"]
   ["MZN" "943" "Mozambican metical" "MT" "centavo"]
   ["NAD" "516" "Namibian dollar" "$" "cent"]
   ["NGN" "566" "Nigerian naira" "₦" "kobo"]
   ["NIO" "558" "Nicaraguan córdoba" "C$" "centavo"]
   ["NOK" "578" "Norwegian krone" "kr" "øre"]
   ["NPR" "524" "Nepalese rupee" "₨" "paisa"]
   ["NZD" "554" "New Zealand dollar" "$" "cent"]
   ["OMR" "512" "Omani rial" "ر.ع." "Baisa"]
   ["PAB" "590" "Panamanian balboa" "B/." "centésimo"]
   ["PEN" "604" "Peruvian nuevo sol" "S/." "cêntimo"]
   ["PGK" "598" "Papua New Guinean kina" "K" "toea"]
   ["PHP" "608" "Philippine peso" "₱" "centavo"]
   ["PKR" "586" "Pakistani rupee" "₨" "paisa"]
   ["PLN" "985" "Polish złoty" "zł" "grosz"]
   ["PYG" "600" "Paraguayan guaraní" "₲" "cêntimo"]
   ["QAR" "634" "Qatari riyal" "ر.ق" "dirham"]
   ["RON" "946" "Romanian new leu" "L" "ban"]
   ["RSD" "941" "Serbian dinar" "дин." "para"]
   ["RUB" "643" "Russian rouble" "руб." "kopek"]
   ["RWF" "646" "Rwandan franc" "Fr" "centime"]
   ["SAR" "682" "Saudi riyal" "ر.س" "halala"]
   ["SBD" "90" "Solomon Islands dollar" "$" "cent"]
   ["SCR" "690" "Seychelles rupee" "₨" "cent"]
   ["SDG" "938" "Sudanese pound" "£" "piastre"]
   ["SEK" "752" "Swedish krona" "kr" "öre"]
   ["SGD" "702" "Singapore dollar" "$" "cent"]
   ["SHP" "654" "Saint Helena pound" "£" "penny"]
   ["SLL" "694" "Sierra leonean leone" "Le" "cent"]
   ["SOS" "706" "Somali shilling" "Sh" "cent"]
   ["SRD" "968" "Surinamese dollar" "$" "cent"]
   ["SSP" "728" "South Sudanese pound" "£" "piastre"]
   ["STD" "678" "São Tomé and Príncipe dobra" "Db" "cêntimo"]
   ["SYP" "760" "Syrian pound" "ل.س" "piastre"]
   ["SZL" "748" "Swazi lilangeni" "L" "cent"]
   ["THB" "764" "Thai baht" "฿" "satang"]
   ["TJS" "972" "Tajikistani somoni" "ЅМ" "diram"]
   ["TMT" "934" "Turkmenistani manat" "m" "tennesi"]
   ["TND" "788" "Tunisian dinar" "د.ت" "millime"]
   ["TOP" "776" "Tongan paʻanga" "T$" "seniti"]
   ["TRY" "949" "Turkish lira" "NULL" "kuruş"]
   ["TTD" "780" "Trinidad and Tobago dollar" "$" "cent"]
   ["TWD" "901" "New Taiwan dollar" "$" "cent"]
   ["TZS" "834" "Tanzanian shilling" "Sh" "cent"]
   ["UAH" "980" "Ukrainian hryvnia" "₴" "kopiyka"]
   ["UGX" "800" "Ugandan shilling" "Sh" "cent"]
   ["USD" "840" "United States dollar" "$" "cent"]
   ["UYU" "858" "Uruguayan peso" "$" "centésimo"]
   ["UZS" "860" "Uzbekistan som" "лв" "tiyin"]
   ["VEF" "937" "Venezuelan bolívar fuerte" "Bs F" "cêntimo"]
   ["VND" "704" "Vietnamese dong" "₫" "hào"]
   ["VUV" "548" "Vanuatu vatu" "Vt" "NULL"]
   ["WST" "882" "Samoan tala" "T" "sene"]
   ["XAF" "950" "CFA franc BEAC" "Fr" "centime"]
   ["XCD" "951" "East Caribbean dollar" "$" "cent"]
   ["XOF" "952" "CFA franc BCEAO" "Fr" "centime"]
   ["XPF" "953" "CFP franc" "Fr" "centime"]
   ["YER" "886" "Yemeni rial" "﷼" "fils"]
   ["ZAR" "710" "South African rand" "R" "cent"]
   ["ZMW" "967" "Zambian kwacha" "ZK" "ngwee"]])

(defonce iso-4217-currencies
  (->> iso-4217-currency-data
       (map (fn [[code numeric-code english-name currency-symbol sub-unit]]
              [(keyword (string/lower-case code))
               {:currency-code   code
                :numeric-code    numeric-code
                :label           english-name
                :currency-symbol currency-symbol
                :sub-unit        sub-unit}]))
       (into {})))

(defn get-symbol
  [code-kw]
  (some-> iso-4217-currencies
          (get code-kw)
          :currency-symbol))

(defonce currencies
  (vec
   (concat
    [[:usd "USD"]
     [:eur "EUR"]
     [:gbp "GBP"]]
    ;;rest sorted alphabetically
    (sort-by
     second
     [[:aed "AED"]
      [:afn "AFN"]
      [:all "ALL"]
      [:amd "AMD"]
      [:ang "ANG"]
      [:aoa "AOA"]
      [:ars "ARS"]
      [:aud "AUD"]
      [:awg "AWG"]
      [:azn "AZN"]
      [:bam "BAM"]
      [:bbd "BBD"]
      [:bdt "BDT"]
      [:bgn "BGN"]
      [:bhd "BHD"]
      [:bif "BIF"]
      [:bmd "BMD"]
      [:bnd "BND"]
      [:bob "BOB"]
      [:bov "BOV"]
      [:brl "BRL"]
      [:bsd "BSD"]
      [:btn "BTN"]
      [:bwp "BWP"]
      [:byn "BYN"]
      [:bzd "BZD"]
      [:cad "CAD"]
      [:cdf "CDF"]
      [:che "CHE"]
      [:chf "CHF"]
      [:chw "CHW"]
      [:clf "CLF"]
      [:clp "CLP"]
      [:cny "CNY"]
      [:cop "COP"]
      [:cou "COU"]
      [:crc "CRC"]
      [:cuc "CUC"]
      [:cup "CUP"]
      [:cve "CVE"]
      [:czk "CZK"]
      [:djf "DJF"]
      [:dkk "DKK"]
      [:dop "DOP"]
      [:dzd "DZD"]
      [:egp "EGP"]
      [:ern "ERN"]
      [:etb "ETB"]
      [:fjd "FJD"]
      [:fkp "FKP"]
      [:gel "GEL"]
      [:ghs "GHS"]
      [:gip "GIP"]
      [:gmd "GMD"]
      [:gnf "GNF"]
      [:gtq "GTQ"]
      [:gyd "GYD"]
      [:hkd "HKD"]
      [:hnl "HNL"]
      [:hrk "HRK"]
      [:htg "HTG"]
      [:huf "HUF"]
      [:idr "IDR"]
      [:ils "ILS"]
      [:inr "INR"]
      [:iqd "IQD"]
      [:irr "IRR"]
      [:isk "ISK"]
      [:jmd "JMD"]
      [:jod "JOD"]
      [:jpy "JPY"]
      [:kes "KES"]
      [:kgs "KGS"]
      [:khr "KHR"]
      [:kmf "KMF"]
      [:kpw "KPW"]
      [:krw "KRW"]
      [:kwd "KWD"]
      [:kyd "KYD"]
      [:kzt "KZT"]
      [:lak "LAK"]
      [:lbp "LBP"]
      [:lkr "LKR"]
      [:lrd "LRD"]
      [:lsl "LSL"]
      [:lyd "LYD"]
      [:mad "MAD"]
      [:mdl "MDL"]
      [:mga "MGA"]
      [:mkd "MKD"]
      [:mmk "MMK"]
      [:mnt "MNT"]
      [:mop "MOP"]
      [:mru "MRU"]
      [:mur "MUR"]
      [:mvr "MVR"]
      [:mwk "MWK"]
      [:mxn "MXN"]
      [:mxv "MXV"]
      [:myr "MYR"]
      [:mzn "MZN"]
      [:nad "NAD"]
      [:ngn "NGN"]
      [:nio "NIO"]
      [:nok "NOK"]
      [:npr "NPR"]
      [:nzd "NZD"]
      [:omr "OMR"]
      [:pab "PAB"]
      [:pen "PEN"]
      [:pgk "PGK"]
      [:php "PHP"]
      [:pkr "PKR"]
      [:pln "PLN"]
      [:pyg "PYG"]
      [:qar "QAR"]
      [:ron "RON"]
      [:rsd "RSD"]
      [:rub "RUB"]
      [:rwf "RWF"]
      [:sar "SAR"]
      [:sbd "SBD"]
      [:scr "SCR"]
      [:sdg "SDG"]
      [:sek "SEK"]
      [:sgd "SGD"]
      [:shp "SHP"]
      [:sll "SLL"]
      [:sos "SOS"]
      [:srd "SRD"]
      [:ssp "SSP"]
      [:stn "STN"]
      [:svc "SVC"]
      [:syp "SYP"]
      [:szl "SZL"]
      [:thb "THB"]
      [:tjs "TJS"]
      [:tmt "TMT"]
      [:tnd "TND"]
      [:top "TOP"]
      [:try "TRY"]
      [:ttd "TTD"]
      [:twd "TWD"]
      [:tzs "TZS"]
      [:uah "UAH"]
      [:ugx "UGX"]
      [:usn "USN"]
      [:uyi "UYI"]
      [:uyu "UYU"]
      [:uyw "UYW"]
      [:uzs "UZS"]
      [:ves "VES"]
      [:vnd "VND"]
      [:vuv "VUV"]
      [:wst "WST"]
      [:xaf "XAF"]
      [:xag "XAG"]
      [:xau "XAU"]
      [:xba "XBA"]
      [:xbb "XBB"]
      [:xbc "XBC"]
      [:xbd "XBD"]
      [:xcd "XCD"]
      [:xdr "XDR"]
      [:xof "XOF"]
      [:xpd "XPD"]
      [:xpf "XPF"]
      [:xpt "XPT"]
      [:xsu "XSU"]
      [:xts "XTS"]
      [:xua "XUA"]
      [:xxx "XXX"]
      [:yer "YER"]
      [:zar "ZAR"]
      [:zmw "ZMW"]
      [:zwl "ZWL"]
      [:usdt "USDT"]
      [:btc "BTC"]]))))

(defonce options
  (->> currencies
       (map (fn [[k l]]
              {:key   k
               :label l}))))

(def value-options
  (->> currencies
       (map (fn [[k l]]
              {:value k
               :label l}))))

(def value-options-by-value
  (->> value-options
       (map (fn [{:keys [value] :as opt}]
              [value opt]))
       (into {})))

(def value-lookup
  (->> currencies
       (mapcat (fn [[k l]]
                 [[(cu/str-trim-lcase (name k)) k]
                  [(cu/str-trim-lcase (pr-str k)) k]
                  [(cu/str-trim-lcase l) k]
                  [l k]]))
       (into {})))

(def multipliers
  ["1" "k" "M" "lacs" "Cr"])

(def currencies-map
  (->> currencies
       (into {})))

(def inverse-currencies-map
  (set/map-invert currencies-map))

(defn get-label
  [key]
  (get currencies-map key))

(defn get-key
  [label]
  (get inverse-currencies-map label))
